import React from 'react'
import { Link } from 'react-router-dom'
import { FiAlertTriangle } from 'react-icons/fi'

class ContentErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('Page crashed inside the dashboard shell', error, info)
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null })
    }
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div
        role='alert'
        className='tw-mx-auto tw-flex tw-max-w-xl tw-flex-col tw-items-center tw-gap-3 tw-rounded-2xl tw-bg-white tw-px-6 tw-py-10 tw-text-center tw-shadow-card'
      >
        <FiAlertTriangle aria-hidden='true' className='tw-h-14 tw-w-14 tw-text-danger' strokeWidth={1.5} />
        <h2 className='tw-font-heading tw-text-[20px] tw-font-semibold tw-text-ink'>
          Something went wrong on this page
        </h2>
        <p className='tw-text-[14px] tw-text-inkSoft'>
          The rest of your dashboard still works. Try another page or come back later.
        </p>
        <Link
          to='/'
          className='tw-mt-2 tw-inline-flex tw-h-10 tw-items-center tw-rounded-[10px] tw-bg-ember tw-px-4 tw-text-[14px] tw-font-semibold tw-text-white hover:tw-bg-emberDeep focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ember focus-visible:tw-ring-offset-2'
        >
          Go to Overview
        </Link>
      </div>
    )
  }
}

export default ContentErrorBoundary
